export default __webpack_public_path__ + "locales/cs/Ldap.json?hash=036e8dafebc257831051d15803a95e0e";